import {
  chooseLeagueSheetFiles,
  sanitizeLeagueSheetFileName,
} from "./averageCatalogs";
import { supabase } from "../supabaseClient";

export const SIGNUP_AVERAGE_PROOF_BUCKET = "signup-average-proofs";
export const SIGNUP_PROOF_KIND = "signupProof";

export const proofFileName = (storagePath) => {
  const name = String(storagePath || "").split("/").pop() || "";
  const stripped = name.replace(
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/i,
    ""
  );
  return stripped || name || "Average verification";
};

export const signupProofSheet = (storagePath) => ({
  id: `proof:${storagePath}`,
  storagePath,
  fileName: proofFileName(storagePath),
  source: "Average verification",
  kind: SIGNUP_PROOF_KIND,
});

export const signupProofSheets = (paths) =>
  [...new Set((paths || []).filter(Boolean))].map(signupProofSheet);

export const isSignupProof = (item) => item?.kind === SIGNUP_PROOF_KIND;

export const uploadSignupAverageProof = async ({
  tournamentId,
  userId,
  file,
}) => {
  const { accepted, rejected } = chooseLeagueSheetFiles([file]);
  if (rejected.length) {
    throw new Error(rejected[0]);
  }
  const proofFile = accepted[0];
  if (!proofFile || !userId || !tournamentId) {
    throw new Error("Upload a photo or PDF for average verification.");
  }
  const fileName = sanitizeLeagueSheetFileName(proofFile.name);
  const storagePath = `${userId}/${tournamentId}/${crypto.randomUUID()}-${fileName}`;
  const { error } = await supabase.storage
    .from(SIGNUP_AVERAGE_PROOF_BUCKET)
    .upload(storagePath, proofFile, {
      cacheControl: "3600",
      upsert: false,
      contentType: proofFile.type,
    });
  if (error) {
    throw new Error("Could not upload average verification. Try again.");
  }
  return storagePath;
};

export const createSignupAverageProofSignedUrl = async (
  storagePath,
  expiresIn = 300
) => {
  if (!storagePath) {
    throw new Error("Average verification is not stored.");
  }
  const { data, error } = await supabase.storage
    .from(SIGNUP_AVERAGE_PROOF_BUCKET)
    .createSignedUrl(storagePath, expiresIn);
  if (error || !data?.signedUrl) {
    throw new Error("Could not open average verification.");
  }
  return data.signedUrl;
};

export const deleteSignupAverageProof = async (storagePath) => {
  if (!storagePath) return;
  const { error } = await supabase.storage
    .from(SIGNUP_AVERAGE_PROOF_BUCKET)
    .remove([storagePath]);
  if (error) {
    console.error(error);
  }
};
